import React from 'react';
import PropTypes from 'prop-types';

import ClaimDetailsHeader from './ClaimDetailsHeader';
import ClaimInformation from './ClaimInformation';
import { ExpansionPanel, Typography } from '../../../alf-design';

const ClaimDetails = ({ index, claim, lastClaim }) => {
  return (
    <div>
      <ExpansionPanel
        className=""
        key={claim.claimNumber}
        type="claim"
        header={<ClaimDetailsHeader index={index} claim={claim} />}
        hr={!lastClaim}
      >
        <div>
          <div className="mb-[12px] mt-[17px]">
            <Typography type="h2-claim" component="span">
              Claim details
            </Typography>
          </div>
          <ClaimInformation index={index} claim={claim} />

          {!lastClaim ? <hr className="mt-[16px]" /> : null}
        </div>
      </ExpansionPanel>
    </div>
  );
};

ClaimDetails.propTypes = {
  index: PropTypes.number,
  claim: PropTypes.object,
};

export default ClaimDetails;
